import { useIsAgentThinking } from "@/hooks/use-is-agent-thinking";
import { AgentState } from "@livekit/components-react";

export const VoiceAgentStateIndicator = ({
  agentState,
}: {
  agentState: AgentState;
}) => {
  const isThinking = useIsAgentThinking(agentState);

  return (
    <>
      {isThinking ? (
        <>
          <span className="nut-w-[3px] nut-h-[3px]"></span>
          <span className="nut-w-[3px] nut-h-[3px] nut-animate-sequential-dot-fade-1"></span>
          <span className="nut-w-[3px] nut-h-[3px] nut-animate-sequential-dot-fade-2"></span>
          <span className="nut-w-[3px] nut-h-[3px] nut-animate-sequential-dot-fade-3"></span>
          <span className="nut-w-[3px] nut-h-[3px] nut-animate-sequential-dot-fade-4"></span>
          <span className="nut-w-[3px] nut-h-[3px] nut-animate-sequential-dot-fade-5"></span>
          <span className="nut-w-[3px] nut-h-[3px] nut-animate-sequential-dot-fade-6"></span>
        </>
      ) : agentState === "speaking" ? (
        <>
          <span className="nut-w-[3px] nut-h-[4.7px] nut-transition-opacity nut-duration-1000 nut-animate-pulse"></span>
          <span className="nut-w-[3px] nut-h-[23.3px] nut-transition-opacity nut-duration-1000 nut-animate-pulse"></span>
          <span className="nut-w-[3px] nut-h-[42px] nut-transition-opacity nut-duration-1000 nut-animate-pulse"></span>
          <span className="nut-w-[3px] nut-h-[28px] nut- nut-transition-opacity nut-duration-1000 nut-animate-pulse"></span>
          <span className="nut-w-[3px] nut-h-[14px] nut-transition-opacity nut-duration-1000 nut-animate-pulse"></span>
          <span className="nut-w-[3px] nut-h-[23.3px] nut-transition-opacity nut-duration-1000 nut-animate-pulse"></span>
          <span className="nut-w-[3px] nut-h-[4.7px] nut-transition-opacity nut-duration-1000 nut-animate-pulse"></span>
        </>
      ) : (
        <>
          <span className="nut-w-[3px] nut-h-[3px] rounded-full"></span>
          <span className="nut-w-[3px] nut-h-[3px] rounded-full"></span>
          <span className="nut-w-[3px] nut-h-[3px] rounded-full"></span>
          <span className="nut-w-[3px] nut-h-[3px] rounded-full"></span>
          <span className="nut-w-[3px] nut-h-[3px] rounded-full"></span>
          <span className="nut-w-[3px] nut-h-[3px] rounded-full"></span>
          <span className="nut-w-[3px] nut-h-[3px] rounded-full"></span>
        </>
      )}
    </>
  );
};
